import flyer from '../../img/template_thumnail/word/thumb01_flyer.png';
import flyer2x from '../../img/template_thumnail/word/thumb01_flyer@2x.png';
import invitation1 from '../../img/template_thumnail/word/thumb02_invitation1.png';
import invitation12x from '../../img/template_thumnail/word/thumb02_invitation1@2x.png';
import invitation2 from '../../img/template_thumnail/word/thumb03_invitation2.png';
import invitation22x from '../../img/template_thumnail/word/thumb03_invitation2@2x.png';
import invitation3 from '../../img/template_thumnail/word/thumb04_invitation3.png';
import invitation32x from '../../img/template_thumnail/word/thumb04_invitation3@2x.png';
import letter1 from '../../img/template_thumnail/word/thumb05_letter1.png';
import letter12x from '../../img/template_thumnail/word/thumb05_letter1@2x.png';
import letter2 from '../../img/template_thumnail/word/thumb06_letter2.png';
import letter22x from '../../img/template_thumnail/word/thumb06_letter2@2x.png';
import minutes from '../../img/template_thumnail/word/thumb07_minutes.png';
import minutes2x from '../../img/template_thumnail/word/thumb07_minutes@2x.png';
import officialdocument from '../../img/template_thumnail/word/thumb09_officialdocument.png';
import officialdocument2x from '../../img/template_thumnail/word/thumb09_officialdocument@2x.png';
import poster from '../../img/template_thumnail/word/thumb10_poster.png';
import poster2x from '../../img/template_thumnail/word/thumb10_poster@2x.png';
import recipe from '../../img/template_thumnail/word/thumb11_recipe.png';
import recipe2x from '../../img/template_thumnail/word/thumb11_recipe@2x.png';
import report1 from '../../img/template_thumnail/word/thumb12_report1.png';
import report12x from '../../img/template_thumnail/word/thumb12_report1@2x.png';
import report2 from '../../img/template_thumnail/word/thumb13_report2.png';
import report22x from '../../img/template_thumnail/word/thumb13_report2@2x.png';
import resume1 from '../../img/template_thumnail/word/thumb14_resume1.png';
import resume12x from '../../img/template_thumnail/word/thumb14_resume1@2x.png';
import resume2 from '../../img/template_thumnail/word/thumb15_resume2.png';
import resume22x from '../../img/template_thumnail/word/thumb15_resume2@2x.png';

export const WordTemplate = {
  templatePath: '/template/word/',
  width: '106px',
  height: '153px',
  items: [
    {
      thumnailImage: flyer,
      thumnailImage2x: flyer2x,
      titlei18nID: 'WordTemplateItems.flyer',
      fileName: 'Flyer.docx'
    },
    {
      thumnailImage: invitation1,
      thumnailImage2x: invitation12x,
      titlei18nID: 'WordTemplateItems.invitation1',
      fileName: 'Invitation 1.docx'
    },
    {
      thumnailImage: invitation2,
      thumnailImage2x: invitation22x,
      titlei18nID: 'WordTemplateItems.invitation2',
      fileName: 'Invitation 2.docx'
    },
    {
      thumnailImage: invitation3,
      thumnailImage2x: invitation32x,
      titlei18nID: 'WordTemplateItems.invitation3',
      fileName: 'Invitation 3.docx'
    },
    {
      thumnailImage: letter1,
      thumnailImage2x: letter12x,
      titlei18nID: 'WordTemplateItems.letter1',
      fileName: 'Letter 1.docx'
    },
    {
      thumnailImage: letter2,
      thumnailImage2x: letter22x,
      titlei18nID: 'WordTemplateItems.letter2',
      fileName: 'Letter 2.docx'
    },
    {
      thumnailImage: minutes,
      thumnailImage2x: minutes2x,
      titlei18nID: 'WordTemplateItems.minutes',
      fileName: 'Minutes.docx'
    },
    {
      thumnailImage: officialdocument,
      thumnailImage2x: officialdocument2x,
      titlei18nID: 'WordTemplateItems.officialdocument',
      fileName: 'Official document.docx'
    },
    {
      thumnailImage: poster,
      thumnailImage2x: poster2x,
      titlei18nID: 'WordTemplateItems.poster',
      fileName: 'Poster.docx'
    },
    {
      thumnailImage: recipe,
      thumnailImage2x: recipe2x,
      titlei18nID: 'WordTemplateItems.recipe',
      fileName: 'Recipe.docx'
    },
    {
      thumnailImage: report1,
      thumnailImage2x: report12x,
      titlei18nID: 'WordTemplateItems.report1',
      fileName: 'Report 1.docx'
    },
    {
      thumnailImage: report2,
      thumnailImage2x: report22x,
      titlei18nID: 'WordTemplateItems.report2',
      fileName: 'Report 2.docx'
    },
    {
      thumnailImage: resume1,
      thumnailImage2x: resume12x,
      titlei18nID: 'WordTemplateItems.resume1',
      fileName: 'Resume 1.docx'
    },
    {
      thumnailImage: resume2,
      thumnailImage2x: resume22x,
      titlei18nID: 'WordTemplateItems.resume2',
      fileName: 'Resume 2.docx'
    }
  ]
};
